import { im_proto } from '../../proto/index.js';
import { Logger } from '../metrics/logger.js';

const Request = im_proto.Request;
const Response = im_proto.Response;
const Frame = im_proto.Frame;
function getBase64(arr) {
    if (typeof btoa !== 'undefined') {
        return btoa(String.fromCharCode.apply(null, new Uint8Array(arr)));
    }
    return '';
}
function serialize(req) {
    const buffer = Request.encode(req).finish();
    return new Uint8Array(buffer);
}
function deserialize(ctx, elements) {
    const buffer = new Uint8Array(elements);
    try {
        const res = Response.decode(buffer);
        return res;
    }
    catch (error) {
        const dump = getBase64(buffer);
        Logger.ctxWarn(ctx, 'decode response error: ', error);
        Logger.ctxDebug(ctx, 'hex dump: ', dump);
        throw dump;
    }
}
function serializeFrame(frame) {
    const buffer = Frame.encode(frame).finish();
    return new Uint8Array(buffer);
}
function deserializeFrame(ctx, elements) {
    const buffer = new Uint8Array(elements);
    try {
        return Frame.decode(buffer);
    }
    catch (error) {
        const dump = getBase64(buffer);
        Logger.ctxWarn(ctx, 'decode frame error: ', error);
        Logger.ctxDebug(ctx, 'hex dump: ', dump);
        throw dump;
    }
}

export { deserialize, deserializeFrame, serialize, serializeFrame };
//# sourceMappingURL=serializer.js.map
